export const ApartmentInfoController = "ApartmentInfoController";
